import React from 'react';
import styled, { css } from 'styled-components';

interface ContentProps {
  $scrollable: boolean;
}

const Content = styled.div<ContentProps>(
  ({ theme, $scrollable }) => css`
    margin: 0;
    padding: 1rem 0;
    font-weight: 400;
    scrollbar-width: thin;
    scrollbar-color: ${theme.paper.default} ${theme.paper.modal};

    ${$scrollable &&
    css`
      overflow-y: auto;
    `}
  `
);

interface ModalContentProps {
  children: React.ReactNode;
  scrollable?: boolean;
}

export function ModalContent({
  children,
  scrollable = false,
}: ModalContentProps) {
  return <Content $scrollable={scrollable}>{children}</Content>;
}
